import React, { useState, useEffect, useMemo } from "react";
import { MdDeleteOutline } from "react-icons/md";
import { Eye } from "lucide-react";
import { TbEdit,TbEye } from "react-icons/tb";
import AddUser from "./Assets/AddUser";
import EditUser from "./Assets/EditUser";
import DeleteUser from "./Assets/DeviceChangeModal";
import { toast } from "react-toastify";
import ViewUser from "./Assets/NotificationModel";

const UserDetails = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [daysFilter, setDaysFilter] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [addUserModel, setAddUserModel] = useState(false);
  const [editUserModel, setEditUserModel] = useState(false);
  const [itemToEdit, setItemToEdit] = useState(null);
  const [viewUserModel, setViewUserModel] = useState(false);
  const [itemToView, setItemToView] = useState(null);

  const itemsPerPage = 20;

  const Auth = localStorage.getItem("authToken");

  useEffect(() => {
    fetchUsers();
  }, []);
  // fetch the all dta
  const fetchUsers = async () => {
    try {
      const response = await fetch("https://backend.sanchalansetu.com/api/v1/users/loginlog", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        },
      });

      if (!response.ok) throw new Error("Failed to fetch users");
      
      const result = await response.json();
      
      
      setUsers(result.login_logs || []);
      setRoles(result.roles || []);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching users:", err);
      setError(err.message);
      setLoading(false);
    }
  };

  
  const filteredUsers = useMemo(() => {
    const today = new Date();

    let filtered = users.filter((u) => {
      const nameMatch = u.name?.toLowerCase().includes(search.toLowerCase());

      let matchesDate = true;
      if (daysFilter) {
        const createdDate = new Date(u.created_at);
        if (!isNaN(createdDate)) {
          const diffTime = today - createdDate;
          const diffDays = diffTime / (1000 * 60 * 60 * 24);
          matchesDate = diffDays <= parseInt(daysFilter);
        } else {
          matchesDate = false;
        }
      }

      return nameMatch && matchesDate;
    });

    
    if (sortOption === "name-asc") {
      filtered.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    } else if (sortOption === "name-desc") {
      filtered.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
    } else if (sortOption === "date-asc") {
      filtered.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );
    } else if (sortOption === "date-desc") {
      filtered.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    }

    return filtered;
  }, [users, search, daysFilter, sortOption]);

  // Pagination Method
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentUsers = filteredUsers.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  
  const handleEditUserClick = (user) => {
    setItemToEdit(user);
    setEditUserModel(true);
  };

  const cancelEditUser = () => {
    setEditUserModel(false);
    setItemToEdit(null);
  };

  const confirmEditUser = async (formData) => {
    try {

      const response = await fetch(`https://backend.sanchalansetu.com/api/v1/users/edit/${formData.id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`,
        },
        body: JSON.stringify(formData), 
      });

      const errorText = await response.json();
      
      if (!response.ok) {
        
        toast.error(errorText.message || "User Updated Successfully");
        throw new Error(`Failed to save user: ${errorText}`);
      }else{
        toast.success(errorText.message || "User Updated Successfully");
      }
    } catch (error) {
      console.error("Error saving user:", error);
    }
    fetchUsers();
    setEditUserModel(false);
    setItemToEdit(null);
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setDeleteModalShow(true);
  };

  const confirmDelete = async () => {
    try {


      const response = await fetch(`https://backend.sanchalansetu.com/api/v1/notification/update/${itemToDelete}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        }  
      });

      const errorText = await response.json();
      if (!response.ok) {
        throw new Error(`Failed to delete user: ${errorText}`);
      }else{
        toast.success(errorText.message || "User deleted successfully");
        
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
    fetchUsers();
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  const cancelDelete = () => {
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

        const handleViewClick = (id) => {
          
      setItemToView(id);
      setViewUserModel(true);
    };



        const cancelView = () => {
      setViewUserModel(false);
      setItemToView(null);
    };
    const handleDeviceSelect = async (id) => {
      if (!id) return;
      try {
        const Auth = localStorage.getItem("authToken"); 
        const response = await fetch(`https://backend.sanchalansetu.com/api/v1/device-change/notification/${id}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Auth}`,
          },
          
        });
        const data = await response.json();

        if (response.ok) {
          toast.success(data.message || "Device updated successfully.");
          fetchUsers();
          
        } else {
          console.error("Error sending notification:", data);
          
          toast.error(data.message || "Failed to change device!");


        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("Something went wrong.");

      }
    };


  return (
    <div className="Task-Details-Container">
      <h2 className="text-xl font-semibold mb-4">User Login Details </h2>
      <div className="flex justify-between items-center mb-4">
      
      
      <div className="flex justify-end flex-wrap gap-4 mb-4">
        <input
          type="text"
          placeholder="Search by user name..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          className="px-4 py-2 border rounded"
        />

        
      </div>
      </div>

      
      <table className="w-full text-sm border user-table">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">#</th>
            <th className="px-4 py-2 text-left">Name</th>
            <th className="px-4 py-2 text-left">Latest Model Details</th>
            <th className="px-4 py-2 text-left">LogIn Time</th>
            <th className="px-4 py-2 text-left">Change Model Details For Notification</th>
            <th className="px-4 py-2 text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          {currentUsers.length > 0 ? (
            currentUsers.map((u, index) => (
              <tr key={u.id || index} className="border-t">
                <td className="px-4 py-2">{startIndex + index + 1}</td>
                <td className="px-4 py-2"><div className="flex items-center space-x-2"><span>{u.name || "N/A"}</span></div></td>
                <td className="px-4 py-2">{u.mobile_details || "N/A"}</td>
                <td className="px-4 py-2">{u.created_at || "N/A"}</td>
                <td className="px-4 py-2">
                  <select
                    onChange={(e) => handleDeviceSelect(e.target.value)}
                  >
                    <option value="">Select device to send Notification</option>
                    {u.extra_devices.map((e, index) => (
                      <option key={index} value={e.id}>
                        {e.mobile_details + " - " + e.created_at}
                      </option>
                    ))}
                  </select>


                </td>
                <td className="px-4 py-2 flex gap-2">
                  <button className="text-blue-500 hover:text-blue-700" onClick={() => handleViewClick(u.user_id)}>
                    <TbEye size={22}  />
                  </button>
                  <button className="text-red-500 hover:text-red-700" onClick={() => handleDeleteClick(u.id)}>
                    <MdDeleteOutline size={22} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center py-4 text-gray-500">
                No users found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      
      <div className="flex justify-center mt-4 gap-2 items-center">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <span className="ml-4 text-sm text-gray-600">
          Page {currentPage} / {totalPages || 1}
        </span>

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
      
      {editUserModel && (
        <EditUser
          user={itemToEdit}
          onClose={cancelEditUser}
          onEdit={(formData) => confirmEditUser(formData)}
        />
      )}
      {deleteModalShow && (
        <DeleteUser
          itemName={
            currentUsers.find((p) => p.id === itemToDelete)?.name || "Unknown User"
          }
          deviceName ={
            currentUsers.find((p) => p.id === itemToDelete)?.mobile_details || "Unknown User"
          }
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}
      {viewUserModel && (
        <ViewUser
          user={itemToView || null}
          onClose={cancelView}
        />
      )}
      
    </div>
  );
};

export default UserDetails;


const formatDateTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return isNaN(date.getTime()) ? "" : date.toLocaleString();
};
